import { render, staticRenderFns } from "./SalaryPaymentLayout.vue?vue&type=template&id=71725508&scoped=true&"
import script from "./SalaryPaymentLayout.vue?vue&type=script&lang=js&"
export * from "./SalaryPaymentLayout.vue?vue&type=script&lang=js&"
import style0 from "./SalaryPaymentLayout.vue?vue&type=style&index=0&id=71725508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71725508",
  null
  
)

component.options.__file = "SalaryPaymentLayout.vue"
export default component.exports